import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { sendErrorReport } from '../utilities/sendErrorReport';

export const QUERY_STALE_TIMES = {
    DEFAULT: 30 * 1000, // 30 seconds
    DOSSIER: 30 * 1000, // 30 seconds
    DOSSIER_OVERVIEW: 2 * 60 * 1000, // 2 minutes
    DISCUSSION: 2 * 60 * 1000, // 2 minutes
    AGENT_SETTINGS: 5 * 60 * 1000, // 5 minutes - agent settings change infrequently
    DISSATISFACTION_CATEGORIES: 5 * 60 * 1000, // 5 minutes - testimonial data rarely changes
} as const;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: QUERY_STALE_TIMES.DEFAULT,
        },
    },
    queryCache: new QueryCache({
        onError: (error) => {
            sendErrorReport(error);
        },
    }),
    mutationCache: new MutationCache({
        onError: (error) => {
            sendErrorReport(error);
        },
    }),
});
